import React from "react";
import ResponsibleGambling from "../../components/client-side/responsiblegambling/ResponsibleGambling";

const ResponsibleGamblinePage = () => {
  return (
    <div>
      <main>
        <ResponsibleGambling/>
      </main>
    </div>
  );
};

export default ResponsibleGamblinePage;
